const TEST_BASE_RE = /^\/test(\/|$)/;
const RECOMMEND_ROUTE_RE = /^\/recommend(\/|$)/;
const DETAIL_ROUTE_RE = /^\/detail(\/|$)/;
const GROUP_ROUTE_RE = /^\/group(\/|$)/;
const HOME_ROUTE_RE = /^\/h(\/|$)/;
const CRAWLER_RE = /(bot|spider|crawl|slurp|bingpreview|baiduspider|googlebot|bingbot|bytespider|sogou|360spider|yisouspider|shenma|duckduckbot|yandex|facebookexternalhit|twitterbot|linkedinbot|petalbot|semrushbot|ahrefsbot)/i;

export const getAppBasename = (pathname = window.location.pathname) => {
  return TEST_BASE_RE.test(pathname) ? '/test' : '';
};

export const withAppBasename = (path = '') => {
  if (!path) {
    return getAppBasename() || '/';
  }

  if (/^(https?:)?\/\//.test(path)) {
    return path;
  }

  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  const basename = getAppBasename();

  if (!basename) {
    return normalizedPath;
  }

  if (normalizedPath === basename || normalizedPath.startsWith(`${basename}/`)) {
    return normalizedPath;
  }

  return `${basename}${normalizedPath}`;
};

export const getAppPathname = (pathname = window.location.pathname) => {
  const basename = getAppBasename(pathname);

  if (basename && pathname === basename) {
    return '/';
  }

  if (basename && pathname.startsWith(`${basename}/`)) {
    return pathname.slice(basename.length) || '/';
  }

  return pathname || '/';
};

export const isCrawlerUserAgent = (userAgent = window.navigator.userAgent) => {
  return CRAWLER_RE.test(userAgent || '');
};

export const isRecommendRoute = (pathname = window.location.pathname) => {
  return RECOMMEND_ROUTE_RE.test(getAppPathname(pathname));
};

export const shouldSkipAutoWxAuth = (pathname = window.location.pathname, userAgent = window.navigator.userAgent) => {
  const appPathname = getAppPathname(pathname);

  if (RECOMMEND_ROUTE_RE.test(appPathname)) {
    return true;
  }

  if ((DETAIL_ROUTE_RE.test(appPathname) || GROUP_ROUTE_RE.test(appPathname) || HOME_ROUTE_RE.test(appPathname)) && isCrawlerUserAgent(userAgent)) {
    return true;
  }

  return false;
};

export default {
  getAppBasename,
  getAppPathname,
  isCrawlerUserAgent,
  isRecommendRoute,
  shouldSkipAutoWxAuth,
  withAppBasename,
};
